export default "__VITE_ASSET__e5683c7e__"